export default "__VITE_ASSET__CHZYg66k__"